// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "db72a9962b18608649763c6e3888d01a4e8e3ead/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"41":"de5ada12","440":"486bdddc","581":"a474c96c","788":"2a969f7a","804":"1cf18fe1","810":"5b7541cc"}[chunkId] + ".chunk.js";
};